<div class=" bg-light text-center font-weight-bold">
    <p><strong>Hace tu pedido:</strong>
        Whatsapp <a href="https://wa.me/542922412750"><img src="./assets/images/logo_whatsapp.svg" width="30" height="30"></a>
        | Telefono fijo <img src="./assets/images/logo_te.svg" width="30" height="30"> 2922 462079 / 462341 interno 13 y 17 
        | Correo electrónico a <a href="mailto:pedidosweb@antoniolfano.com.ar"><img src="./assets/images/logo_email.svg" width="30" height="30"></a>
    </p>
</div>